/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./OfferRedemptionPopup.scss";
import { useHistory } from "react-router-dom";

// material ui
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

// localizations
import { withTranslation, useTranslation } from "react-i18next";
// redux
import { useSelector, useDispatch } from "react-redux";
import { get_lang } from "../../../../global-functions/apiGlobal";
import boubyanImg from "../../../js/assets/images/bobeyan.png";

function OfferRedemptionPopup({ offer, onClose }) {
  const history = useHistory();
  const appDispatch = useDispatch();
  const { t } = useTranslation();
  const appState = useSelector((state) => state);

  // Debug logging
  console.log("OfferRedemptionPopup rendered with offer:", offer);

  useEffect(() => {
    console.log("OfferRedemptionPopup mounted");
    return () => {
      console.log("OfferRedemptionPopup unmounted");
    };
  }, []);

  const handleClose = () => {
    console.log("Closing popup");
    if (onClose) {
      onClose();
    }
  };

  const handleRedeem = () => {
    // Handle redemption logic here
    console.log("Redeeming offer:", offer);
    // You can dispatch actions here to handle the redemption
    handleClose();
  };
  console.log(offer)
  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 2,
        }}
        open={true}
        className="offerRedemptionBackdrop"
        onClick={handleClose}
      />
      <div
        id="mySidenav"
        className={`offer-redemption-popup   ${
          appState.langValue === "ar" ? "PayForItemsArabic" : " "
        }`}
      >

        <div className="close-button-container " style={appState.langValue === "ar" ? {left: "20px", right: "auto"} : {right: "20px", left: "auto"}}>
          <button className="close-button" onClick={handleClose}>
            <CloseIcon />
          </button>
        </div>
        
        {/* <a href="javascript:void(0)" className="closebtn" onClick="closeNav()">&times;</a> */}
        <div className="container-fluid content px-4 pb-3 mt-3">
      {/* Main Content */}
      <div className="offer-content">
          {/* Illustration */}
          {offer?.image ? (
            <div className="offer-illustration">        
              {/* <img src={offer.image} alt="Offer Illustration" width={130} height={130} /> */}
              <img src={boubyanImg} alt="Offer Illustration" width={130} height={130} />
            </div>
          ) : 
          boubyanImg?  
          <div className="offer-illustration">
            <img src={boubyanImg} alt="Offer Illustration" width={130} height={130} />
          </div>
          :  (
          <div className="offer-illustration">
            {/* <div className="illustration-container">
           
              <div className="illustration-elements">
                <div className="ribbon"></div>
                <div className="scooter"></div>
                <div className="cube">
                  <span className="cube-logo">t</span>
                </div>
                <div className="floating-shapes">
                  <div className="shape shape-1"></div>
                  <div className="shape shape-2"></div>
                  <div className="shape shape-3"></div>
                </div>
              </div>
            </div> */}
              <img src={boubyanImg} alt="Offer Illustration" width={130} height={130} />

          </div>)}

          {/* Offer Title */}
          <div className="offer-title">
              <h2>{get_lang (offer?.name, appState.langValue)}</h2>
              {/* <h6 className="text-success font-weight-bold mt-1">{Number(offer?.discount).toFixed(2)} KWD</h6> */}
              {offer.description != null &&
                          get_lang(offer.description, appState.langValue) !=
                          null
                          ? get_lang(offer.description, appState.langValue) !=
                            "N/A"
                            ? get_lang(offer.description, appState.langValue)
                              .split(/<br\s*\/?>|\r\n|\r|\n/) // Regex to split by <br>, \r\n, \r, or \n
                              .map((item, i) => (
                                <p
                                  key={i}
                                  className={`d-flex m-0 ${appState.langValue === "ar"
                                      ? "text-right"
                                      : "text-left"
                                    }`}
                                >
                                  {item}
                                </p>
                              ))
                            : ""
                          : ""}
          </div>
          <div>
            <div 
              className="offer-description"
              dangerouslySetInnerHTML={{
                __html: offer?.description || ""
              }}
            />

          </div>

          {/* Offer Details */}
            {/* <div className="offer-details " >
              <div className="detail-item">
                <div className="detail-icon">
                  <div className="coin-stack">
                    <div className="coin coin-1">
                      <span className="coin-logo">t</span>
                    </div>
                    <div className="coin coin-2"></div>
                    <div className="coin coin-3"></div>
                  </div>
                </div>
                <div className="detail-text">
                  <span className="detail-label">Redeem For</span>
                  <span className="detail-value">{offer?.points || "500"} points</span>
                </div>
              </div>

              <div className="detail-item">
                <div className="detail-icon">
                  <div className="coins-with-sparkles">
                    <div className="coin orange-coin">
                      <span className="coin-logo">t</span>
                    </div>
                    <div className="coin brown-coin"></div>
                    <div className="sparkle sparkle-1">✨</div>
                    <div className="sparkle sparkle-2">✨</div>
                    <div className="sparkle sparkle-3">✨</div>
                  </div>
                </div>
                <div className="detail-text">
                  <span className="detail-label">Min Spend</span>
                  <span className="detail-value">KD {offer?.minSpend || "4.5"}</span>
                </div>
              </div>

              <div className="detail-item">
                <div className="detail-icon">
                  <div className="calendar">
                    <div className="calendar-header">
                      <div className="calendar-day marked">{offer?.validDays || "14"}</div>
                    </div>
                    <div className="calendar-body">
                      <div className="calendar-grid">
                        <div className="calendar-cell"></div>
                        <div className="calendar-cell"></div>
                        <div className="calendar-cell"></div>
                        <div className="calendar-cell"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="detail-text">
                  <span className="detail-label">Valid For</span>
                  <span className="detail-value">{offer?.validDays || "14"} days</span>
                </div>
              </div>
            </div> */}

          {/* Redeem Button */}
          {/* <div className="redeem-button-container">
            <Button
              className="redeem-button"
              onClick={handleRedeem}
              variant="contained"
            >
              Redeem
            </Button>
          </div> */}
        </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(OfferRedemptionPopup);
